import React from 'react';
import { SearchResultItem } from './search_result_item';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const SearchResultList = createReactClass({
  handleHover(i) {
    this.props.handleResultHover(i);
  },
  render() {
    let results = this.props.items.map((result, index) => {
      if (result.slug == null) return null;
      return (
        <SearchResultItem
          selected={this.props.currentSelection == index}
          data={result}
          idx={index}
          term={this.props.term}
          hoverHandle={this.handleHover}
          currentUser={this.props.currentUser}
          mobileBrowser={this.props.mobileBrowser}
          languageRegionCode={this.props.languageRegionCode}
          homePage={this.props.homePage}
          handleItemClick={this.props.handleItemClick}
          displayMetric={this.props.displayMetric}
          latLngForDisplayDistance={this.props.latLngForDisplayDistance}
        />
      );
    });
    if (results.length === 0) {
      results = (
        <div className="no-results">
          <span>{StringConstantsMixin.strings.NO_RESULTS}</span>
        </div>
      );
    }

    return (
      <div key="search-result-list" id="hits">
        {results}
      </div>
    );
  }
});

export { SearchResultList };
